import { React, useState, useContext, useEffect } from "react";
import { Dropdown, StatusIcon, Container, Flex, Skeleton, CaretRight, DotsThree, Text } from "@cisco/spaces-dash-lib-styleguide";
import Root from "../../assets/images/location-details/summary/root.svg";
import ApZone from "../../assets/images/location-details/summary/ap_zone.svg";
import Building from "../../assets/images/location-details/summary/building.svg";
import Campus from "../../assets/images/location-details/summary/campus.svg";
import Cmx from "../../assets/images/location-details/summary/cmx.svg";
import Floor from "../../assets/images/location-details/summary/floor.svg";
import Group from "../../assets/images/location-details/summary/group.svg";
import Location from "../../assets/images/location-details/summary/location.svg";
import Meraki from "../../assets/images/location-details/summary/meraki.svg";
import Network from "../../assets/images/location-details/summary/network.svg";
import Org from "../../assets/images/location-details/summary/org.svg";
import PolygonZone from "../../assets/images/location-details/summary/polygon_zone.svg";
import Wlc from "../../assets/images/location-details/summary/wlc.svg";
import Zone from "../../assets/images/location-details/summary/zone.svg";
import OutdoorArea from "../../assets/images/location-details/summary/outdoor_area.svg";
import LockIcon from "../../assets/images/location-details/lock-icon.svg";
import LocationRenamePopup from "../popups/location-rename/location-rename-popup";
import LocationDeletePopup from "../popups/location-delete/location-delete-popup";
import LocationAlertPopup from "../popups/location-alert/location-alert-popup";
import AddEditController from "../popups/add-edit-controller/add-edit-controller";
import ModifyAccessPoints from "../popups/modify-access-points/modify-access-points";
import { I18nContext } from "../../contexts/i18nContext";
import "./business-location-details.scss";
import "../../common/common_style.scss";
import "../../common/global_style.scss";
import useLoader from "../../hooks/useLoader";
import { deleteLocationLh2, getDeleteLocationStatus, renameLoc2 } from "../../service/business-hierarchy-service";
import useNotification from "../../hooks/useNotification";

function BusinessLocationDetails(props) {
  const { goToLocationTab, selectedNode, selectedNodeDetails, wlcLocationData, locationRowMap, isSmartLicenseRegistered, isLicenseFetched, setModalOpened } = props;
  const { setLoading } = useLoader();
  const { setToastMessage } = useNotification();
  const i18n = useContext(I18nContext);
  const [node, setNode] = useState(selectedNode);
  const [locImg, setLocImg] = useState("");
  const [showAddEditController, setShowAddEditController] = useState(false);
  const [showModifyAccessPoint, setShowModifyAccessPoint] = useState(false);
  const [locNameArr, setLocNameArr] = useState([]);
  const [alerts, setAlerts] = useState([]);
  // const [showActions, setShowActions] = useState(false);
  const [countPattern, setCountPattern] = useState([]);
  const [locationName, setLocationName] = useState("");
  const [wirelessText, setWirelessText] = useState("");
  const [wlcCount, setWlcCount] = useState({
    apsCount: 0,
    locationId: null,
    locationName: null,
    wlcLocationId: null
  });
  const [showCountLoader, setShowCountLoader] = useState(false);
  const [showRenamePopup, setShowRenamePopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const locationTypeImages = {
    Root,
    ApZone,
    Building,
    Campus,
    Cmx,
    Floor,
    Group,
    Location,
    Meraki,
    Network,
    Org,
    PolygonZone,
    Wlc,
    Zone,
    OutdoorArea,
    LockIcon
  };

  const prepareLocImg = () => {
    if (node && node.data && node.data.type) {
      let type = node.data.type ? node.data.type[0] : "";
      if (node.data.type.length > 1) {
        if (node.data.type.indexOf("CAMPUS") > -1 && (node.data.type.indexOf("ORG") > -1 || node.data.type.indexOf("MERAKI") > -1)) {
          type = "CAMPUS";
        }
      }
      let locType = type.toLowerCase();
      locType = locType === "network" ? "building" : locType;
      locType = locType === "ap_zone" ? "zone" : locType;
      if (locType) {
        locType = locType
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join("");
      }
      setLocImg(locationTypeImages[`${locType}`]);
    }
  };

  const cancelRename = () => {
    setLocationName("");
    setShowRenamePopup((current) => !current);
    setModalOpened(false);
  };

  const renameLocation = async () => {
    console.log("Renamed Location::", locationName);
    if (locationName && locationName.trim() !== "") {
      setLoading(true);
      const locPayload = {
        locationName: locationName.trim()
      };

      try {
        const res = await renameLoc2(node.data.id, locPayload);
        console.log(res);
        setLoading(false);
        cancelRename();
        setToastMessage(i18n.t("business-location-details.location-renamed-successfully-msg"), 4000, "positive");
      } catch (error) {
        setLoading(false);
        cancelRename();
        setToastMessage(i18n.t("business-location-details.error-ocurred-renaming-location-msg"), 4000, "negative");
      }
    } else {
      setToastMessage(i18n.t("business-location-details.provide-name-for-location-msg"), 4000, "negative");
    }
  };

  const cancelDelete = () => {
    setShowDeletePopup((current) => !current);
    setModalOpened(false);
  };

  const deleteLocation = async () => {
    cancelDelete();
    const locationId = node.data.id;

    if (locationId) {
      setLoading(true);
      try {
        const res = await deleteLocationLh2(locationId);

        if (res && res.status) {
          setToastMessage(i18n.t("business-location-details.location-delete-in-progress-msg"), 5000, "positive");
          const deleteStatus = await getDeleteLocationStatus(locationId);
          console.log("deleteStatus", deleteStatus);
        } else {
          setToastMessage(res.message, 5000, "negative");
        }
        setLoading(false);
        goToLocationTab();
      } catch (error) {
        setLoading(false);
        setToastMessage(i18n.t("business-location-details.error-on-deleting-location-msg"), 4000, "negative");
        console.error(error);
      }
    } else {
      setToastMessage(i18n.t("business-location-details.error-on-deleting-location-msg"), 4000, "negative");
    }
  };

  const toggleAlerts = () => {
    setShowAlertPopup((current) => !current);
  };

  const goToLocationEdit = () => {
    toggleAlerts();
    goToLocationTab();
  };

  const toggleActions = () => {
    // setShowActions((current) => !current);
  };

  const showDelete = () => {
    toggleActions();
    setShowDeletePopup((current) => !current);
    setModalOpened(true);
  };

  const showRename = () => {
    toggleActions();
    setLocationName(node && node.data ? node.data.name : "");
    setShowRenamePopup((current) => !current);
    setModalOpened(true);
  };

  const showAddEditCtrlPopup = () => {
    toggleActions();
    setModalOpened(true);
    setShowAddEditController((current) => !current);
  };

  const canShowSection = () => {
    if (node && node.data && node.data.type && node.data.type[0] != "ROOT") {
      return true;
    }
    return false;
  };

  const canShowTimeZoneAlert = () => {
    const restrictedLocationTypes = ["FLOOR", "POLYGON_ZONE", "GROUP", "AP_ZONE"];
    if (node.data.type && node.data.type[0] && restrictedLocationTypes.indexOf(node.data.type[0]) > -1) {
      return false;
    }
    return true;
  };

  const prepareWlcAlerts = () => {
    setWlcCount({
      apsCount: 0,
      locationId: null,
      locationName: null,
      wlcLocationId: null
    });
    const locationId = node.data.id;
    if (wlcLocationData && wlcLocationData.length) {
      const wlcCont = wlcLocationData.filter((e) => e.wlcLocationId === locationId);
      if (wlcCont && wlcCont.length) {
        setWlcCount({ ...wlcCont[0] });

        if (wlcCont && wlcCont.apsCount && wlcCont.apsCount > 0) {
          if (alerts.indexOf("wlcCount") == -1) {
            setAlerts((alert) => [...alert, "wlcCount"]);
          }
        }
      }
    }
  };

  const timeZoneAndAlerts = () => {
    if (node && node.data) {
      if (!node.data.inferredTimeZoneId) {
        if (canShowTimeZoneAlert()) {
          if (alerts.indexOf("timezone") == -1) {
            setAlerts((alert) => [...alert, "timezone"]);
          }
        }
      }
      if (node.data.type && node.data.type[0] == "WLC") {
        prepareWlcAlerts();
      }
    }
  };

  const getLocationPath = (locPathIds) => {
    const newNames = [];
    if (locPathIds && locPathIds.length) {
      locPathIds.forEach((id) => {
        const loc = locationRowMap[id];
        if (loc) {
          newNames.push(loc.name);
        }
      });
    }
    setLocNameArr(newNames);
    return newNames;
  };

  const prepareLocPath = () => {
    if (node && node.data && node.data.locationPath && node.data.locationPath.length) {
      console.log(getLocationPath(node.data.locationPath));
    } else {
      setLocNameArr([]);
    }
  };

  const titleCase = (str) => {
    const splitStr = str.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  };

  const prepareCountPattern = () => {
    if (selectedNodeDetails && selectedNodeDetails.countPattern) {
      const countPatternStr = selectedNodeDetails.countPattern;
      const countArr = countPatternStr.split(" | ");
      // Accumulate the results in a temporary array
      const newCountPattern = countArr.map((count) => {
        const [countValue, label] = count.split(":");
        return {
          count: countValue,
          label: titleCase(label)
        };
      });
      // Update state with the accumulated array
      setCountPattern(newCountPattern);
      console.log(newCountPattern);
      // console.log(newCountPattern);
      // TODO: this.countPatternEmit.emit(newCountPattern);
    }
  };

  const canShowAddEditCtrls = () => {
    if (node && node.data && node.data.type && node.data.type.length && node.data.type[0].toLowerCase() == "wlc") {
      return true;
    }
    return false;
  };

  const canShowModifyAccessPoint = () => {
    if (node && node.data && node.data.type && node.data.type.length && node.data.type[0].toLowerCase() == "ap_zone") {
      return true;
    }
    return false;
  };

  const showModifyAccessPoints = () => {
    toggleActions();
    setModalOpened(true);
    setShowModifyAccessPoint((current) => !current);
  };

  const cancelModifyAccessPoint = () => {
    setModalOpened(false);
    setShowModifyAccessPoint((current) => !current);
  };

  const cancelAddEditCtrlPopup = () => {
    setModalOpened(false);
    setShowAddEditController((current) => !current);
  };

  function ContainerLoader() {
    return (
      <Flex direction="vertical" gap={24}>
        <Container
          style={{
            height: 194,
            width: 1095,
            paddingLeft: 27,
            borderBottom: "1px solid #d9d9d9",
            boxShadow: "none",
            borderRadius: 0
          }}
        >
          <Flex gap={24}>
            <Skeleton
              height={50}
              style={{
                width: 50
              }}
            />
            <Flex direction="vertical" gap={12} grow>
              <Skeleton
                height="md"
                style={{
                  width: "40%"
                }}
              />
              <Skeleton
                height="sm"
                style={{
                  width: "15%",
                  marginLeft: "-10px"
                }}
              />
            </Flex>
          </Flex>
          <Flex gap={50} style={{ paddingTop: "30px" }}>
            <Skeleton
              height={45}
              style={{
                width: 32
              }}
            />
            <Skeleton
              height={45}
              style={{
                width: 32
              }}
            />
            <Skeleton
              height={45}
              style={{
                width: 32
              }}
            />
            <Skeleton
              height={45}
              style={{
                width: 32
              }}
            />
            <Skeleton
              height={45}
              style={{
                width: 32
              }}
            />
            <Skeleton
              height={45}
              style={{
                width: 32
              }}
            />
          </Flex>
          <Flex gap={40}>
            <Skeleton
              height="12px"
              style={{
                width: "45px",
                marginTop: "5px",
                height: "12px"
              }}
            />
            <Skeleton
              height="12px"
              style={{
                width: "45px",
                marginTop: "5px",
                height: "12px"
              }}
            />
            <Skeleton
              height="12px"
              style={{
                width: "45px",
                marginTop: "5px",
                height: "12px"
              }}
            />
            <Skeleton
              height="12px"
              style={{
                width: "45px",
                marginTop: "5px",
                height: "12px"
              }}
            />
            <Skeleton
              height="12px"
              style={{
                width: "45px",
                marginTop: "5px",
                height: "12px"
              }}
            />
            <Skeleton
              height="12px"
              style={{
                width: "45px",
                marginTop: "5px",
                height: "12px"
              }}
            />
          </Flex>
        </Container>
      </Flex>
    );
  }

  useEffect(() => {
    console.log("BusinessLocationDetails Mount");
    setNode((prev) => ({
      ...prev,
      data: locationRowMap[selectedNode?.data?.id]
    }));

    prepareLocPath();
    prepareLocImg();
    timeZoneAndAlerts();
    if (selectedNodeDetails) {
      setShowCountLoader(false);
      prepareCountPattern();
    } else {
      setShowCountLoader(false);
    }
    setWirelessText("Wireless Controller");

    return () => {
      console.log("BusinessLocationDetails Destroy");
    };
  }, [selectedNodeDetails, locationRowMap]);

  return (
    <>
      {(!node || !node.data) && <ContainerLoader />}
      {node && node.data && (
        <Container
          style={{
            padding: "24px 24px 18px 24px",
            "border-bottom": "1px solid #d9d9d9",
            "box-shadow": "none",
            "border-radius": 0
          }}
        >
          <div className="bh-loc-main">
            <LocationRenamePopup showRenamePopup={showRenamePopup} cancelRename={cancelRename} renameLocation={renameLocation} locationName={locationName} setLocationName={setLocationName} />
            <LocationDeletePopup showDeletePopup={showDeletePopup} cancelDelete={cancelDelete} deleteLocation={deleteLocation} node={node} />
            <LocationAlertPopup
              alerts={alerts}
              showAlertPopup={showAlertPopup}
              toggleAlerts={toggleAlerts}
              showUncategorisedList={false}
              wlcCount={wlcCount}
              showUncategorisedAps={false}
              goToLocationEdit={goToLocationEdit}
            />
            {showAddEditController && (
              <AddEditController
                showAddEditController={showAddEditController}
                setShowAddEditController={setShowAddEditController}
                cancelAddEditCtrlPopup={cancelAddEditCtrlPopup}
                selectedNode={selectedNode}
              />
            )}
            {showModifyAccessPoint && <ModifyAccessPoints showModifyAccessPoint={showModifyAccessPoint} cancelModifyAccessPoint={cancelModifyAccessPoint} selectedNode={selectedNode} />}

            {node && node.data && (
              <div className="bh-loc-heading">
                <div className="bh-loc-split">
                  <div className="bh-loc-img">
                    <div className="bh-img-box">{locImg && <img src={locImg} alt="location icon" />}</div>
                  </div>
                  <div className="bh-loc-info">
                    <Flex className="bh-loc-name">
                      {node.data.name}
                      {node.data && node.data.access !== "Full" && <img title="You do not have access to modify this location" src={LockIcon} alt="permission-icon" />}
                      {node.data && node.data.access == "Full" && (
                        <span className="location-action-wrapper">
                          {/* <span className="rename-link" role="presentation" onClick={toggleActions}>
                            <DotsThreeVertical size={24} weight="bold" kind="primary" />
                          </span> */}
                          <Dropdown icon={<DotsThree size={28} weight="bold" />} kind="tertiary">
                            <Dropdown.Item label={i18n.t("business-location-details.rename-location-text")} onClick={showRename} />
                            {canShowSection() && <Dropdown.Item label={i18n.t("business-location-details.delete-location-text")} onClick={showDelete} />}
                            {canShowAddEditCtrls() && <Dropdown.Item label={i18n.t("add-edit-controller.add-edit-controller-text")} onClick={showAddEditCtrlPopup} />}
                            {canShowModifyAccessPoint() && <Dropdown.Item label={i18n.t("ap-zone.modify-access-points-text")} onClick={showModifyAccessPoints} />}
                          </Dropdown>
                        </span>
                      )}
                    </Flex>
                    {locNameArr.length !== 0 && (
                      <div className="bh-loc-path">
                        {locNameArr.map((name, index) => (
                          <span className="path-name" key={`locname_${name}`}>
                            <Text size="p4" weight="regular" color="light">
                              {name}
                              {index < locNameArr.length - 1 && (
                                <span className="path-right-arrow">
                                  <CaretRight size={13} />
                                </span>
                              )}
                            </Text>
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            className="bh-loc-main"
            style={{
              "padding-top": "30px",
              "margin-left": "-16px",
              "border-right": isSmartLicenseRegistered && isLicenseFetched ? "1px solid #d9d9d9" : "0px"
            }}
          >
            <div className="bh-loc-heading">
              <div className="bh-loc-split">
                <div className="bh-loc-info">
                  <div className="bh-loc-counts">
                    {showCountLoader && countPattern && countPattern.length > 0 && (
                      <div className="count-loader-container">
                        <div className="placeholder-content">
                          <div className="placeholder-content_item" />
                          <div className="placeholder-content_item" />
                          <div className="placeholder-content_item" />
                          <div className="placeholder-content_item" />
                          <div className="placeholder-content_item" />
                          <div className="placeholder-content_item" />
                          <div className="placeholder-content_item" />
                          <div className="placeholder-content_item" />
                          <div className="placeholder-content_item" />
                        </div>
                      </div>
                    )}
                    {countPattern &&
                      countPattern.length > 0 &&
                      countPattern.map(
                        (count) =>
                          count.label.length > 0 && (
                            <div className="bh-count-pattern" key={`count_for_${count.label}`}>
                              <div className="count-name">{count.count < 10 ? `0${count.count}` : count.count}</div>
                              <div className="count-label">
                                <Text size="p3" weight="regular">
                                  {count.label == "wlc" || count.label == "Wlc" || count.label == "WLC" ? wirelessText : count.label}
                                </Text>
                              </div>
                            </div>
                          )
                      )}
                    {alerts.length > 0 && (
                      <div className="bh-count-pattern alert-count">
                        <div className="count-name" role="button" tabIndex={-5} onKeyDown={toggleAlerts} onClick={toggleAlerts}>
                          {alerts.length}
                          <span style={{ position: "relative", top: "4px" }}>
                            <StatusIcon status="warning" />
                          </span>
                        </div>
                        <div className="count-label">
                          <Text size="p3" weight="regular">
                            {i18n.t("business-location-details.alerts-text")}
                          </Text>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      )}
    </>
  );
}

export default BusinessLocationDetails;
